export const STREAMS = {
    lettres: [
        { subject: "Arabe", coefficient: 4 },
        { subject: "Philosophie", coefficient: 4 },
        { subject: "Histoire-Géo", coefficient: 3 },
        { subject: "Français", coefficient: 3 },
        { subject: "Anglais", coefficient: 3 },
        { subject: "Pensée Islamique", coefficient: 1 },
        { subject: "Informatique", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 1 },
    ],

    mathematiques: [
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Physique", coefficient: 3 },
        { subject: "Sciences", coefficient: 1 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
        { subject: "Philosophie", coefficient: 1 },
        { subject: "Informatique", coefficient: 1 },
        { subject: "Arabe", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 1 },
    ],

    sciences_experimental: [
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Physique", coefficient: 4 },
        { subject: "Sciences", coefficient: 4 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
        { subject: "Philosophie", coefficient: 2 },
        { subject: "Informatique", coefficient: 1 },
        { subject: "Arabe", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 1 },
    ],

    economie_gestion: [
        { subject: "Économie", coefficient: 4 },
        { subject: "Gestion", coefficient: 4 },
        { subject: "Mathématiques", coefficient: 2.5 },
        { subject: "Histoire-Géo", coefficient: 3 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
        { subject: "Philosophie", coefficient: 1 },
        { subject: "Informatique", coefficient: 1 },
        { subject: "Arabe", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 1 },
    ],

    technique: [
        { subject: "Technique", coefficient: 3 },
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Physique", coefficient: 3 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
        { subject: "Philosophie", coefficient: 1 },
        { subject: "Arabe", coefficient: 1 },
        { subject: "Informatique", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 1 },
    ],

    informatique: [
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Algorithmique", coefficient: 3 },
        { subject: "Physique", coefficient: 2 },
        { subject: "Sti", coefficient: 1.5 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
        { subject: "Philosophie", coefficient: 1 },
        { subject: "Arabe", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 1 },
    ],

    sport: [
        { subject: "Biologie", coefficient: 1.5 },
        { subject: "Spécialité Sport", coefficient: 1 },
        { subject: "Éducation Physique", coefficient: 0.5 },
        { subject: "Physique", coefficient: 0.5 },
        { subject: "Philosophie", coefficient: 0.5 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
        { subject: "Arabe", coefficient: 1 },
        { subject: "Option", coefficient: 0 },
        { subject: "Sport", coefficient: 0.5 },
    ],
};
export const FILTERED_STREAMS = {
    lettres: [
        { subject: "Arabe", coefficient: 4 },
        { subject: "Philosophie", coefficient: 4 },
        { subject: "Histoire-Géo", coefficient: 3 },
        { subject: "Français", coefficient: 3 },
        { subject: "Anglais", coefficient: 3 },
    ],

    mathematiques: [
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Physique", coefficient: 3 },
        { subject: "Sciences", coefficient: 1 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 }
    ],

    sciences_experimental: [
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Physique", coefficient: 4 },
        { subject: "Sciences", coefficient: 4 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 }
    ],

    economie_gestion: [
        { subject: "Économie", coefficient: 4 },
        { subject: "Gestion", coefficient: 4 },
        { subject: "Mathématiques", coefficient: 2.5 },
        { subject: "Histoire-Géo", coefficient: 3 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 }
    ],

    technique: [
        { subject: "Technique", coefficient: 3 },
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Physique", coefficient: 3 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 }
    ],

    informatique: [
        { subject: "Mathématiques", coefficient: 3 },
        { subject: "Algorithmique", coefficient: 3 },
        { subject: "Physique", coefficient: 2 },
        { subject: "Sti", coefficient: 1.5 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
    ],

    sport: [
        { subject: "Biologie", coefficient: 1.5 },
        { subject: "Spécialité Sport", coefficient: 1 },
        { subject: "Éducation Physique", coefficient: 0.5 },
        { subject: "Physique", coefficient: 0.5 },
        { subject: "Philosophie", coefficient: 0.5 },
        { subject: "Français", coefficient: 1 },
        { subject: "Anglais", coefficient: 1 },
    ],
};
export const SECTIONS = [
    {
        key: "lettres",
        label: "Lettres",
    },
    {
        key: "mathematiques",
        label: "Mathématiques",
    },
    {
        key: "sciences_experimental",
        label: "Sciences Expérimentales",
    },
    {
        key: "economie_gestion",
        label: "Économie et Gestion",
    },
    {
        key: "technique",
        label: "Technique",
    },
    {
        key: "informatique",
        label: "Informatique",
    },
    {
        key: "sport",
        label: "Sport",
    },
];

export const FORM_VALIDATION = {
    grade: {
        required: 'Ce champ est requis',
        min: { value: 0, message: 'La note doit être au moins 0' },
        max: { value: 20, message: 'La note maximal est 20' },
        inputProps: {
            min: 0,
            max: 20,
            step: '0.01',
        },
    },
    average: {
        required: 'Ce champ est requis',
        min: { value: 0, message: 'La moyenne doit être au moins 0' },
        max: { value: 20.40, message: 'La moyenne ne peut pas dépasser 20.40' },
        inputProps: {
            min: 0,
            max: 20.40,
            step: '0.01',
        },
    },
};


export const SCORE_WEIGHTS = {
    Lettres: {
        average: 4,
        'Arabe': 1.5,
        'Philosophie': 1.5,
        'Histoire-Géo': 1,
        'Français': 1,
        'Anglais': 1,
    },
    Mathématiques: {
        average: 4,
        'Mathématiques': 2,
        'Physique': 1.5,
        'Sciences': 0.5,
        'Français': 1,
        'Anglais': 1,
    },
    'Sciences Expérimentales': {
        average: 4,
        'Mathématiques': 1,
        'Physique': 1.5,
        'Sciences': 1.5,
        'Français': 1,
        'Anglais': 1,
    },
    'Économie et Gestion': {
        average: 4,
        'Économie': 1.5,
        'Gestion': 1.5,
        'Mathématiques': 0.5,
        'Histoire-Géo': 0.5,
        'Français': 1,
        'Anglais': 1,
    },
    Technique: {
        average: 4,
        'Technique': 1.5,
        'Mathématiques': 1.5,
        'Physique': 1,
        'Français': 1,
        'Anglais': 1,
    },
    Informatique: {
        average: 4,
        'Mathématiques': 1.5,
        'Algorithmique': 1.5,
        'Physique': 0.5,
        'Sciences': 0.5,
        'Français': 1,
        'Anglais': 1,
    },
    Sport: {
        average: 4,
        'Biologie': 1.5,
        'Spécialité Sport': 1,
        'Éducation Physique': 0.5,
        'Physique': 0.5,
        'Philosophie': 0.5,
        'Français': 1,
        'Anglais': 1,
    },
};

export const SCORE_FORMULAS = {
    Lettres: (average, grades) =>
        4 * average +
        1.5 * (grades['Arabe'] || 0) +
        1.5 * (grades['Philosophie'] || 0) +
        1 * (grades['Histoire-Géo'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
    Mathématiques: (average, grades) =>
        4 * average +
        2 * (grades['Mathématiques'] || 0) +
        1.5 * (grades['Physique'] || 0) +
        0.5 * (grades['Sciences'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
    'Sciences Expérimentales': (average, grades) =>
        4 * average +
        1 * (grades['Mathématiques'] || 0) +
        1.5 * (grades['Physique'] || 0) +
        1.5 * (grades['Sciences'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
    'Économie et Gestion': (average, grades) =>
        4 * average +
        1.5 * (grades['Économie'] || 0) +
        1.5 * (grades['Gestion'] || 0) +
        0.5 * (grades['Mathématiques'] || 0) +
        0.5 * (grades['Histoire-Géo'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
    Technique: (average, grades) =>
        4 * average +
        1.5 * (grades['Technique'] || 0) +
        1.5 * (grades['Mathématiques'] || 0) +
        1 * (grades['Physique'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
    Informatique: (average, grades) =>
        4 * average +
        1.5 * (grades['Mathématiques'] || 0) +
        1.5 * (grades['Algorithmique'] || 0) +
        0.5 * (grades['Physique'] || 0) +
        0.5 * (grades['Sti'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
    Sport: (average, grades) =>
        4 * average +
        1.5 * (grades['Biologie'] || 0) +
        1 * (grades['Spécialité Sport'] || 0) +
        0.5 * (grades['Éducation Physique'] || 0) +
        0.5 * (grades['Physique'] || 0) +
        0.5 * (grades['Philosophie'] || 0) +
        1 * (grades['Français'] || 0) +
        1 * (grades['Anglais'] || 0),
};
// Dynamically generate AVERAGE_FORMULAS from STREAMS data
export const AVERAGE_FORMULAS = Object.keys(STREAMS).reduce((acc, streamKey) => {
    const section = SECTIONS.find(s => s.key === streamKey);
    const label = section?.label || streamKey;
    
    acc[label] = (grades) => {
      let totalWeightedScore = 0;
      let totalCoefficient = 0;
      let optionBonus = 0;
      
      STREAMS[streamKey].forEach(({ subject, coefficient }) => {
        const cleanSubject = subject.replace(' *', '');
        const grade = grades[cleanSubject] !== undefined && !isNaN(grades[cleanSubject]) ? grades[cleanSubject] : 0;
        if (subject === 'Option' && grade > 10) {
          optionBonus = (grade - 10) / 2;
          totalWeightedScore += optionBonus;
        }
        if (coefficient > 0) {
          totalWeightedScore += grade * coefficient;
          totalCoefficient += coefficient;
        }
      });
      
      const average = totalCoefficient > 0 ? totalWeightedScore / totalCoefficient : 0;
      return parseFloat(average.toFixed(2));
    };
    
    return acc;
  }, {});

export const calculateAverage = (section, grades) => {
    if (!STREAMS[section]) {
        console.warn(`Invalid section: ${section}`);
        return 0;
    }

    let totalWeightedScore = 0;
    let totalCoefficient = 0;
    let optionBonus = 0;

    STREAMS[section].forEach(({ subject, coefficient }) => {
        const cleanSubject = subject.replace(' *', '');
        const grade = grades[cleanSubject] !== undefined && !isNaN(grades[cleanSubject]) ? grades[cleanSubject] : 0;
        if (subject === 'Option' && grade > 10) {
            optionBonus = (grade - 10) / 2;
            totalWeightedScore += optionBonus;
        }
        if (coefficient > 0) {
            totalWeightedScore += grade * coefficient;
            totalCoefficient += coefficient;
        }
    });

    const average = totalCoefficient > 0 ? totalWeightedScore / totalCoefficient : 0;
    const cappedAverage = Math.min(average, 20.4);
    return parseFloat(cappedAverage.toFixed(2));
};